import React, {useContext} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import { SnackbarContent } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import PageContext from '../../contexts/PageContext'

const useStyles = makeStyles((theme) => ({
    logo: {
		display: "flex",
		alignItems:"flex-end",
		width: 120,
		textDecoration: "none",
		marginTop: '10px',
        marginBottom: '10px',
		"& img": {
			width: 80,
			height: "auto",
		},
		"& span": {
			fontSize: 14,
			fontWeight: 600,
			letterSpacing:2,
			color: "#ddd",
			marginLeft: 10,
			marginBottom:4
		}
	},
    active: {
        textDecoration: 'none',
        color: 'grey'
    }
})); 

const brightTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#f7f7f7',
      },
    },
  });
  
const Header = () => {
    const pageContext = useContext(PageContext);
    let navigate = useNavigate();
    const location = useLocation();

    const classes = useStyles();
    const logout = () => {
        localStorage.removeItem('token');
        return navigate("/");
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <ThemeProvider theme={brightTheme}>
                <AppBar position="static" color="primary" enableColorOnDark>
                    <Toolbar>
                        <NavLink
                            to="/"
                            className={classes.logo}
                        >
                            <img src="/Logo_BIMM_2022.png" alt="logo"/>
                        </NavLink>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        </Typography>
            
                        <NavLink className= { 
                        (thisNav) => thisNav.isActive ? classes.active : ''}
                        to='/dashboard'>
                            <Button variant="text" color="inherit">Dashboard</Button>
                        </NavLink>
                        <NavLink className= { 
                        (thisNav) => thisNav.isActive ? classes.active : ''}
                        to='/users'>
                            <Button variant="text" color="inherit">Benutzer bearbeiten</Button>
                        </NavLink>      
                        <Button variant="text" color="inherit" onClick={logout}>Abmelden</Button>
                    </Toolbar>
                </AppBar>
            </ThemeProvider>
            {pageContext.infoMessage && (
				<Snackbar
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					open={
						pageContext.infoMessage !== null && pageContext.infoMessage !== ""
					}
					autoHideDuration={6000}
					onClose={() => {
						pageContext.setInfoMessage("");
					}}
				>
					<SnackbarContent 
						className={classes.infoMessageBarContent}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar">
								<InfoIcon className={classes.snackbarIcon} />
								{pageContext.infoMessage}
							</span>
						}
					/>
				</Snackbar>
			)}
        </Box>
	);
}

export default Header;